export default __webpack_public_path__ + "static/media/mask5.1d222654.jpeg";